import React from "react";

// Redirect
import { useNavigate } from "react-router-dom";

// Classnames
import clsx from "clsx";

// Components
import Img from "./Img";

// Interface
interface IBack {
  url?: string,
  label?: string,
  className?: string,
}

export const NavigationBack: React.FC<IBack> = (props) => {
  const navigate = useNavigate();

  const {
    url,
    label,
    className
  } = props;

  const handlerClickBack = () => {
    if (url) {
      navigate(url);
    } else {
      navigate(-1);
    }
  };

  const cn = clsx(
    "back flex flex-ai-center",
    className ? className : ""
  );

  return (
    <div
      className={cn}
      onClick={handlerClickBack}
    >
      <Img isSvg name="arrowSvg" alt="Back" className="back__arrow" />
      {!!label && <p>{label || "Back"}</p>}
    </div>
  );
};

export default NavigationBack;
